import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'protocols-string-list-input',
  standalone: true,
  imports: [MatIcon, TranslatePipe],
  templateUrl: './string-list-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StringListInputComponent {
  readonly items = input.required<string[]>();
  readonly itemsChange = output<string[]>();

  protected readonly draft = signal('');

  protected add(): void {
    const value = this.draft().trim();
    if (!value) {
      return;
    }
    this.itemsChange.emit([...this.items(), value]);
    this.draft.set('');
  }

  protected remove(index: number): void {
    this.itemsChange.emit(this.items().filter((_, i) => i !== index));
  }

  protected onInput(event: Event): void {
    this.draft.set((event.target as HTMLInputElement).value);
  }
}
